import { render, staticRenderFns } from "./CustomerDetailsLoanHistory.vue?vue&type=template&id=1683aa03"
import script from "./CustomerDetailsLoanHistory.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsLoanHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports